import Web3 from "web3";
import GAMEFOREST from "./contracts_token/GAMEFOREST.json";
import GAMEFORESTTaxReceiverForwardAdmin from "./contracts_token/GAMEFORESTTaxReceiverForwardAdmin.json";
import GAMEFORESTSale from "./contracts/GAMEFORESTSale.json";



const options = {
  web3: {
    block: false,
    customProvider: null,
  },
  contracts: [GAMEFOREST, GAMEFORESTTaxReceiverForwardAdmin, GAMEFORESTSale],
  events: {
    //GAMEFORESTSale: ["TimedCrowdsaleExtended", "TokensPurchased", "RefundsClosed", "RefundsEnabled"],
    FinalizableCrowdsale: ["CrowdsaleFinalized"],
  },
  syncAlways:false,
  init: (drizzleOptions) => {
    var web3;

    if(typeof drizzleOptions.web3.customProvider != "string" &&
    drizzleOptions.web3.customProvider != null) {
      return;
    }

    if (typeof window.ethereum !== 'undefined') {
      // If a web3 instance is already provided by Meta Mask.
      web3 = new Web3(window.ethereum);
    } else {
      // Specify default instance if no web3 instance provided
      web3 = "Press the button below to connect";
    }

    drizzleOptions.web3.customProvider = web3;
  }
};

export default options;
